export default "__VITE_ASSET__2823da96__"